"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5849 7.402C5.7662 5.943 7.5703 5 9.8855 5c2.9088 0 4.9136 1.4831 5.9172 3.369.9681 1.8192 1.0345 4.1009-.0358 5.6897-1.2796 1.8996-3.5361 2.4845-5.4092 2.1093-1.8808-.3767-3.6713-1.8062-3.6713-4.1679 0-.9998.3593-1.8331.9714-2.4133.5986-.5675 1.3799-.8368 2.1385-.8368.7587 0 1.5399.2693 2.1385.8368.6122.5802.9714 1.4135.9714 2.4133h-2c0-.5004-.1682-.7921-.3473-.9618-.1926-.1826-.4663-.2883-.7626-.2883-.2963 0-.57.1057-.7626.2883-.179.1697-.3473.4614-.3473.9618 0 1.1382.8246 1.9586 2.0641 2.2069 1.2472.2498 2.6164-.1653 3.3576-1.2657.5667-.8413.6331-2.3096-.071-3.6328C13.3684 8.0518 12.0287 7 9.8855 7c-1.7266 0-2.954.682-3.7462 1.6605-.8101 1.0006-1.211 2.3715-1.1288 3.7813.0819 1.4055.641 2.7906 1.673 3.8184C7.7029 17.2757 9.2412 18 11.401 18H21v2h-9.599c-2.6399 0-4.7013-.9007-6.129-2.3227-1.4152-1.4097-2.1506-3.2746-2.2582-5.1191-.1072-1.8402.4077-3.7193 1.5711-5.1562z"
  })];
};

exports.default = _default;